import { COLORS } from './chartColors';
import { SelectedEntity } from './helpers/types';
import { groupByKey } from './helpers/dataGroupingHelpers';

interface SourceRecord {
  source_name: string;
}

interface SourceData {
  data: SourceRecord[] | { reportNotFound: boolean };
}

export const applicationCountSourceTransformer = (
  data: Record<string, SourceData>,
  selectedEntities: SelectedEntity[]
) => {
  // Flatten all records and filter by selected entities
  const allRecords: SourceRecord[] = [];
  Object.entries(data).forEach(([key, value]) => {
    const [entity_id] = key.split('_');
    const isAllSelected = selectedEntities?.some((entity: SelectedEntity) => entity.name === 'All');
    const isEntitySelected = selectedEntities?.some(
      (entity: SelectedEntity) => entity.id.toString() === entity_id
    );
    if (selectedEntities && !isAllSelected && !isEntitySelected) {
      return;
    }
    if (Array.isArray(value.data)) {
      value.data.forEach((record) => {
        allRecords.push(record);
      });
    }
  });

  // Group by source_name
  const sourceCounts = groupByKey(allRecords, (record) => record.source_name || 'Unknown');

  return {
    labels: Object.keys(sourceCounts),
    datasets: [
      {
        data: Object.values(sourceCounts),
        borderWidth: 1,
        backgroundColor: COLORS.slice(0, Object.keys(sourceCounts).length)
      }
    ]
  };
};
